/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import alerts, { AlertsState } from './alerts';
import boardSelector, { BoardSelectorState } from './board-selector';
import boardsMenu, { BoardsMenuState } from './boards-menu';
import closedBoards, { ClosedBoardsState } from './closed-boards';
import collapsibles, { CollapsiblesState } from './collapsibles';
import createMenu, { CreateMenuState } from './create-menu';
import errors, { ErrorState } from './errors';
import highlights, { UiHighlightsState } from './highlights';
import labels, { LabelUiState } from './labels';
import navigating, { NavigatingState } from './navigating';
import notificationsPane, {
  NotificationsPaneState,
} from './notifications-pane';
import overlay from './overlay';
import popovers, { PopoversState } from './popovers';
import powerUpsDirectory, {
  PowerUpsDirectoryState,
} from './power-ups-directory';
import search, { SearchUiState } from './search';
import superHome, { SuperHomeState } from './super-home';
import tooltips, { TooltipsState } from './tooltips';
import upNext, { UiUpNextState } from './up-next';

export * from './alerts';
export * from './board-selector';
export * from './boards-menu';
export * from './closed-boards';
export * from './collapsibles';
export * from './create-menu';
export * from './highlights';
export * from './labels';
export * from './navigating';
export * from './notifications-pane';
export * from './overlay';
export * from './popovers';
export * from './power-ups-directory';
export * from './search';
export * from './super-home';
export * from './up-next';
export * from './channel-switcher';

export interface UiState {
  alerts: AlertsState;
  boardSelector: BoardSelectorState;
  boardsMenu: BoardsMenuState;
  closedBoards: ClosedBoardsState;
  collapsibles: CollapsiblesState;
  createMenu: CreateMenuState;
  errors: ErrorState;
  highlights: UiHighlightsState;
  labels: LabelUiState;
  navigating: NavigatingState;
  notificationsPane: NotificationsPaneState;
  overlay: string;
  popovers: PopoversState;
  tooltips: TooltipsState;
  powerUpsDirectory: PowerUpsDirectoryState;
  search: SearchUiState;
  superHome: SuperHomeState;
  upNext: UiUpNextState;
}

export default combineReducers({
  alerts,
  boardSelector,
  boardsMenu,
  closedBoards,
  collapsibles,
  createMenu,
  errors,
  labels,
  highlights,
  navigating,
  notificationsPane,
  overlay,
  popovers,
  tooltips,
  powerUpsDirectory,
  search,
  superHome,
  upNext,
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/index.ts